<template lang="html">
  <div id="reschedulingSenderPage">
    <div class="help">
      <span class="help-icon" @click="helpCliked()">
        <i class="icon-question-sign" v-if="!help_cliked"></i>
        <i class="icon-circledelete" v-if="help_cliked"></i>
      </span>
      <div class="help_information" v-if="help_cliked">
        <h2 class="helpH2">振替依頼をする場合</h2>
    		<ol class="helpOl">
    			<li>座席予約表へログイン後、画面左上の「振替を依頼する」をクリック</li>
    			<li>画面の指示に従い、入力を進める</li>
    			<ol class="helpO2">
    				<li>①振替を希望する授業をリストから選択</li>
    				<li>②振替候補日時を選択</li>
    				<li>③振替を希望する理由を入力</li>
    				<li>（講師のみ、④振替後の授業の情報を入力）</li>
    			</ol>
    			<li>入力項目を確認し、「振替依頼をする」ボタンをクリック</li>
    			<li>または、「戻って修正する」ボタンをクリック</li>
    			<li>完了画面を確認し、「座席表トップへ」をクリック</li>
    		</ol>
    		<div class="messagetext">
    			<span class="box-title">振替依頼をしたあとは・・・</span>
    			<p>24時間以内に振替の承認・不承認の結果がメールで届きます。<br>
    				承認された場合は、そのまま振替後の日時に教室にお越しください。<br>
    				不承認された場合は、承認者から別の振替候補日時が提案されますので、再度振替依頼を行ってください。</p>
          </div>
      </div>
    </div>
    <router-view />
    <el-button
      class="btn"
      @click="$router.push('/table')"
    >
      座席予約表トップへ
    </el-button>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        help_cliked: false
      }
    },
    methods: {
      helpCliked () {
        if (!this.help_cliked) {
          this.help_cliked = true
        } else {
          this.help_cliked = false
        }
      }
    }
  }
</script>
<style lang="css" scoped>
  #reschedulingSenderPage {
    text-align: center;
    font-family: 'Avenir','Helvetica Neue','Helvetica','Arial','Hiragino Sans','ヒラギノ角ゴシック',YuGothic,'Yu Gothic','メイリオ', Meiryo,'ＭＳ Ｐゴシック','MS PGothic', 'sans-serif';
    margin-bottom: 50px;
  }
  .help {
    width: auto;
    float: right;
    position: fixed;
    z-index: 100;
    top: 60px;
    right: 10px;
  }
  .help-icon{
    color: #ffd500;
    font-size: 50px;
  }
  .help-icon :hover{
    color: #E69200;
  }
  .help_information{
    width: auto;
    float: right;
    position: fixed;
    z-index: 100;
    top: 115px;
    right: 50px;
    background-size: cover;
    background-color: rgba(255, 255, 255);
    border: solid 3px #6091d3;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// ReschedulingSenderPage.vue?a74ac020